import { render, staticRenderFns } from "./UserProfileWithKeys.vue?vue&type=template&id=dd4b4ca2&"
import script from "./UserProfileWithKeys.vue?vue&type=script&lang=js&"
export * from "./UserProfileWithKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports